import { useLocation, matchPath } from 'react-router-dom'
import { useEffect } from 'react'
import { mixPanelPageTrack } from './MixpanelConfig'
import { trackGAPageView } from './GAConfig'
import { Routings } from '../../Config'

export function PageTracking() {
  const location = useLocation()
  useEffect(() => {
    const currentRoute = Routings.find((route) =>
      matchPath(route.path, location.pathname)
    )
    const title = currentRoute?.title || 'Panenka FC'

    // Set the document title
    document.title = title

    const page = location.pathname + location.search
    // Track pageview with GA4
    trackGAPageView(page, title)

    // Track with Mixpanel
    mixPanelPageTrack(page)

    // Enable the following line for debugging purposes only
    // console.log(page)
  }, [location])

  return null
}
